export const SET_TOKEN = 'SET_TOKEN'
export const SET_THEME = 'SET_THEME'
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA'
export const SET_KEYCLOAK_USER_DATA = 'SET_KEYCLOAK_USER_DATA'
export const SET_SHOW_ALERT = 'SET_SHOW_ALERT'
export const SIGN_OUT = 'SIGN_OUT'
export const SET_PROFILE = 'SET_PROFILE'
